<div class="header">
    <div class="headerContent">
        <h1 mat-dialog-title>{{data.headline}}</h1>   
        <app-go-to-button *ngIf="Person$ | async as data" matDialogClose EntityType="contact" matTooltip="Kontakt" [EntityId]="data.Id"></app-go-to-button>
    </div>
    <div class="headerContent">
        <button mat-icon-button matDialogClose matTooltip="Schließen" aria-label="Schließen">
            <fa-icon icon="times" size="2x"></fa-icon>
        </button>
    </div>
</div>
<ng-container>
    <app-person-detail-form
    [Person]="Person$ | async"
    ></app-person-detail-form>
</ng-container>